{
  "title": "Frostbite",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You cause numbing frost to form on one creature that you can see within range. The target must make a Constitution saving throw. On a failed save, the target takes 1d6 cold damage, and it has disadvantage on the next weapon attack roll it makes before the end of its next turn.",
    "At Higher Levels. The spell’s damage increases by 1d6 when you reach 5th level (2d6), 11th level (3d6), and 17th level (4d6)."
  ],
  "spellLists": [
    "artificer",
    "druid",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "warlock",
    "wizard"
  ]
}
